import React from 'react';
import styled from 'styled-components';
import useSearchParams from '../useSearchParams';
import {Select} from 'components/antd';

const sortCategories = [
  {text: '未選択', value: ''},
  {text: 'メールフォームクリック回数', value: 'clickCount'},
  {text: 'メールフォームクリック日時', value: 'clickUpdatedAt'},
  {text: '従業員数', value: 'employeeNumber'},
  {text: '資本金', value: 'capitalFund'},
  {text: 'リマインド', value: 'reminder'},
];

const sortOrders = [
  {text: '少ない順（昇順）', value: 'asc'},
  {text: '多い順（降順）', value: 'desc'},
];

export default () => {
  const {query, setQuery} = useSearchParams();

  const setCategory = (value: string) => {
    if (value === '') {
      setQuery({
        sortCategory: '',
        sortOrder: '',
        page: 1,
      });
    } else if (query.sortOrder) {
      setQuery({
        sortCategory: value,
        sortOrder: query.sortOrder,
        page: 1,
      });
    } else {
      setQuery({sortCategory: value});
    }
  };

  const setSortOrder = (value: string) => {
    setQuery({
      sortCategory: query.sortCategory,
      sortOrder: value,
      page: 1,
    });
  };

  return (
    <Container>
      <h3>並び替え</h3>

      <div>
        <Select
          value={query.sortCategory}
          onChange={setCategory}
          placeholder="選択してください"
          dropdownMatchSelectWidth={false}>
          {sortCategories.map((category) => (
            <Select.Option
              value={category.value}
              key={category.value}
              label={category.text}
              style={{width: '195px'}}>
              {category.text}
            </Select.Option>
          ))}
        </Select>
        <Select
          value={query.sortOrder}
          disabled={!query.sortCategory}
          onChange={setSortOrder}
          placeholder="選択してください"
          dropdownMatchSelectWidth>
          {sortOrders.map((order) => (
            <Select.Option
              value={order.value}
              key={order.value}
              label={order.text}>
              {order.text}
            </Select.Option>
          ))}
        </Select>
      </div>
    </Container>
  );
};

const Container = styled.div`
  width: 395px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  font-size: 12p;

  h3 {
    font-weight: bold;
    color: var(--text-color-3);
    margin-bottom: 0.5rem;
  }

  > *:nth-child(2) {
    flex: 1;
    display: flex;

    > div {
      flex: 1;

      &:first-child {
        margin-right: 12px;
      }
    }
  }
`;
